import './TooltipHeader.css';
export var formattedTimeframe = '_biijte1-3-5-0';
export var headerItem = '_biijte0-3-5-0';